import { render, staticRenderFns } from "./business-note-detail-modal.vue?vue&type=template&id=78b35cb7&"
import script from "./business-note-detail-modal.vue?vue&type=script&lang=js&"
export * from "./business-note-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports